







function topFunction() {
   document.body.scrollTop = 0; // For Safari
   document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

function setCookie(name,value) {
   var expires = "";
   let days = 7;
   if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
   }
   document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
   var nameEQ = name + "=";
   var ca = document.cookie.split(';');
   for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
   }
   return null;
}
function eraseCookie(name) {
   document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}




//mega
document.querySelectorAll('.menu-has-child').forEach(function(element) {
   element.addEventListener('click', function(event) {
// Отменяем стандартное действие браузера (переход по ссылке)
      event.preventDefault();


      const parentLi = this.closest('li');
      console.log(parentLi);
      if (parentLi) {
         parentLi.classList.toggle('megamenu-mob-show-children');
      }

   });
});

//MEGAMENU
const sourceElement = document.querySelector('.megamenu-categories .megamenu-item__content');
const targetElement = document.querySelector('#megamenu-mob-children-category');
if (sourceElement && targetElement) {
   targetElement.innerHTML = sourceElement.innerHTML;
}
const sourceElementServices = document.querySelector('.megamenu-services .megamenu-item__content');
const targetElementServices = document.querySelector('#megamenu-mob-children-services');
if (sourceElementServices && targetElementServices) {
   targetElementServices.innerHTML = sourceElementServices.innerHTML;
}
const sourceElementFilials = document.querySelector('.megamenu-filials .megamenu-item__content');
const targetElementFilials = document.querySelector('#megamenu-mob-children-filials');
if (sourceElementFilials && targetElementFilials) {
   targetElementFilials.innerHTML = sourceElementFilials.innerHTML;
}
//END





document.querySelectorAll('.go-collback').forEach(function (btn) {
   btn.addEventListener('click', function () {
      document.body.classList.add('popup-show');
      document.querySelector('.bloor-popup').classList.add('turbo-popup__show');
   });
});

document.querySelectorAll('.collback__close').forEach(function (btn) {
   btn.addEventListener('click', function () {
      document.body.classList.remove('collback-show');
   });
});

document.querySelectorAll('.collback').forEach(function (popup) {
   popup.addEventListener('click', function (event) {
      if (event.target === popup) {
         document.body.classList.remove('collback-show');
      }
   });
});





document.querySelectorAll('.collback__close').forEach(function (btn) {
   btn.addEventListener('click', function () {
      document.body.classList.remove('collback-show');
      document.body.classList.remove('collback-special-show');
   });
});

document.querySelectorAll('.collback__close-mob').forEach(function (btn) {
   btn.addEventListener('click', function () {
      document.body.classList.remove('collback-show');
      document.body.classList.remove('collback-special-show');
   });
});

document.querySelectorAll('.collback-special').forEach(function (popup) {
   popup.addEventListener('click', function (event) {
      if (event.target === popup) {
         document.body.classList.remove('collback-show');
         document.body.classList.remove('collback-special-show');
      }
   });
});

document.querySelectorAll('.turbo-popup__close').forEach(function (btn) {
   btn.addEventListener('click', function () {
      document.querySelectorAll('.turbo-popup__show').forEach(function (popup) {
         popup.classList.remove('turbo-popup__show');
      });
      document.body.classList.remove('popup-show');
   });
});

document.querySelectorAll('.turbo-popup').forEach(function (popup) {
   popup.addEventListener('click', function (event) {
      if (event.target === popup) {
         document.querySelectorAll('.turbo-popup__show').forEach(function (openedPopup) {
            openedPopup.classList.remove('turbo-popup__show');
         });
         document.body.classList.remove('popup-show');
      }
   });
});

document.querySelectorAll('#burger-btn').forEach(function (btn) {
   btn.addEventListener('click', function () {
      document.body.classList.add('burger__show');
   });
});

document.querySelectorAll('#burger-btn-close').forEach(function (btn) {
   btn.addEventListener('click', function () {
      document.body.classList.remove('burger__show');
   });
});

document.querySelectorAll('.burger__nav .toggle').forEach(function (link) {
   link.addEventListener('click', function (e) {
      e.preventDefault();
      this.parentNode.parentNode.classList.toggle('sub-show');
   });
});

document.querySelectorAll('.burger').forEach(function (burger) {
   burger.addEventListener('click', function (event) {
      if (event.target === burger) {
         document.body.classList.remove('burger__show');
      }
   });
});